<template>
    <div>
        <h1 class="catalogue-heading">{{catalogueHeading}}</h1>
        <b-container>
            <b-card no-body class="mb-1 catalogue-company-products">
                <b-button block href="#" v-b-toggle="'accordion-' + catalogueHeading.replace(' ', '')" variant="light" class="product-family-heading-button view-products-btn">
                    <h1 class="product-family-heading">
                        View Products ▼
                    </h1>
                </b-button>
                <b-collapse :id="'accordion-' + catalogueHeading.replace(' ', '')" accordion="view-products-accordion" role="tabpanel">
                    <div :key="catalogueIndex + '-' + familyIdx" v-for="(products, productFamily, familyIdx) in catalogueSections" role="tablist">
                        <div v-if="productFamily == 'company-description'">
                            <b-container class='company-description-card'>
                                <b-row>
                                    <b-col v-if="'img' in products">
                                        <img class="company-catalogue-img" :src="require('../assets/img/products/' + products.img)" alt="company image">
                                    </b-col>
                                    <b-col class="company-catalogue-txt" cols="10">{{products.txt}}</b-col>
                                </b-row>
                            </b-container>
                        </div>
                        <div v-else>
                            <b-container>
                                <b-card no-body class="mb-1 catalogue-product-family">
                                        <b-button block href="#" v-b-toggle="'accordion-' + catalogueIndex + '-' + familyIdx" variant="light" class="product-family-heading-button">
                                            <h1 class="product-family-heading">
                                                {{productFamily}}
                                            </h1>
                                        </b-button>
                                        <b-collapse :id="'accordion-' + catalogueIndex + '-' + familyIdx" accordion="catalogue-section-accordion" role="tabpanel">
                                            <b-list-group>
                                                <b-list-group-item v-for="(productDetails, productName, productIdx) in products" :key="productName + productIdx">
                                                    <div v-if="productName != 'family-description'">
                                                        <div class="see-more-button-wrapper">
                                                            <b-button class="transparent-btn" block href="#" v-b-toggle="'see-more-' + catalogueIndex + '-' + familyIdx + '-' + productIdx" variant="light">
                                                                <h1 class="product-name">{{productName}}</h1>
                                                            </b-button>
                                                        </div>
                                                        <b-collapse :id="'see-more-' + catalogueIndex + '-' + familyIdx + '-' + productIdx" accordion="see-more-accordion" role="tabpanel">
                                                            <b-container>
                                                                <b-row class="catalogue-product-description">
                                                                    <p style="font-weight: bold" v-if="'subheading' in productDetails" class="catalogue-product-subheading">{{productDetails.subheading}}</p>
                                                                    <p>{{productDetails.description}}</p>
                                                                </b-row>
                                                                <b-row class="catalogue-product-img-wrapper">
                                                                    <img v-if="'img' in productDetails && productDetails.img != ''" class="catalogue-product-img" :src="require('../assets/img/products/' + productDetails.img)" alt="product image">
                                                                </b-row>
                                                            </b-container>
                                                        </b-collapse>
                                                    </div>
                                                    <div v-else>
                                                        {{productDetails.description}}
                                                    </div>
                                                </b-list-group-item>
                                            </b-list-group>
                                        </b-collapse>
                                </b-card>
                            </b-container>
                        </div>
                    </div>
                </b-collapse>
            </b-card>
        </b-container>
    </div>
</template>

<script>
export default {
    name: 'catalogueSection',
    props: ['catalogueSections', "catalogueHeading", "catalogueIndex"],
    data(){
        return{
            visible: [],
        }
    },
    created(){
        for(let i = 0; i < Object.keys(this.catalogueSections).length; i++){
            this.visible[i] = false
        }
    },
}
</script>